import { PaletteGrid } from '../../../components/PaletteGrid';
import { BackBar } from '../../../components/BackBar';
import type { CharacterRow } from '../../../lib/types';

interface VariantStepProps {
  fighterName: string;
  variants: CharacterRow[];
  selectedId: number | null;
  submitting?: boolean;
  onSelect: (id: number) => void;
  onBack: () => void;
  onContinue: (id: number) => void;
}

export function VariantStep({
  fighterName,
  variants,
  selectedId,
  submitting = false,
  onSelect,
  onBack,
  onContinue,
}: VariantStepProps) {
  return (
    <div className="smash-stage">
      <BackBar onBack={onBack} />
      <div className="smash-banner-wrap">
        <div className="smash-banner">
          <img src="/burst.png" alt="" aria-hidden="true" className="smash-burst" />
          <h1 className="smash-banner__title">Pick your {fighterName} variant!</h1>
        </div>
        {variants[0]?.image_url ? (
          <img
            className="smash-silhouette"
            src={variants[0].image_url}
            alt={fighterName}
          />
        ) : (
          <div className="smash-silhouette smash-silhouette--question">?</div>
        )}
      </div>
      <div className="smash-fighter">
        <PaletteGrid
          variants={variants}
          selectedId={selectedId}
          disabled={submitting}
          onSelectPalette={(id) => {
            if (!submitting) {
              onSelect(id);
              onContinue(id);
            }
          }}
        />
      </div>
    </div>
  );
}
